import * as React from 'react';
import { createContext, useContext, useMemo } from 'react';

export type VideoTrimmingContextType = {
  trimmedStartTimeSeconds: number;

  trimmedDurationSeconds: number | null;

  trimmedEndTimeSeconds: number | null;
};

const defaultContext: VideoTrimmingContextType = {
  trimmedStartTimeSeconds: 0,
  trimmedDurationSeconds: null,
  trimmedEndTimeSeconds: null,
};

export const VideoTrimmingContext = createContext(defaultContext);

type PropsToComponent = {
  trimmedStartTimeSeconds: number;
  trimmedDurationSeconds: number | null;
};

export const VideoTrimmingContextProvider: React.LegacyFunctionComponentWithChildren<PropsToComponent> = ({
  trimmedStartTimeSeconds,
  trimmedDurationSeconds,
  children,
}) => {
  const trimmedEndTimeSeconds = useMemo(
    () => (trimmedDurationSeconds ? trimmedStartTimeSeconds + trimmedDurationSeconds : null),
    [trimmedDurationSeconds, trimmedStartTimeSeconds]
  );
  return (
    <VideoTrimmingContext.Provider
      value={{
        trimmedStartTimeSeconds,
        trimmedDurationSeconds,
        trimmedEndTimeSeconds,
      }}
    >
      {children}
    </VideoTrimmingContext.Provider>
  );
};

export const useVideoTrimmingContext = () => {
  const context = useContext(VideoTrimmingContext);
  if (context) {
    return context;
  }

  // TODO: log errors once top of funnel video flows are set up (and spots like interactive transcript can access this context as expected).  return the default context (ie values when no trimmed range is available) instead.
  //   Sentry.captureMessage(`Tried to access video trimming context where unavailable`, {
  // level: 'warning',
  // });
  return defaultContext;
};

export default useVideoTrimmingContext;
